"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IN_PROGRESS = exports.ASSIGNABLE = exports.DeploymentStatus = void 0;
var DeploymentStatus;
(function (DeploymentStatus) {
    DeploymentStatus["ACCEPTED"] = "accepted";
    DeploymentStatus["AFTER_PHOTO_TAKEN"] = "after_photo_taken";
    DeploymentStatus["BEFORE_PHOTO_TAKEN"] = "before_photo_taken";
    DeploymentStatus["CANCELED"] = "canceled";
    DeploymentStatus["CUSTOMER_CALLED"] = "customer_called";
    DeploymentStatus["DISPATCHED"] = "dispatched";
    DeploymentStatus["DONE"] = "done";
    DeploymentStatus["DONE_TRADER_PAID"] = "done_trader_paid";
    DeploymentStatus["DONE_WAITING_INVOICE"] = "done_waiting_invoice";
    DeploymentStatus["DONE_WAITING_PAYOUT"] = "done_waiting_payout";
    DeploymentStatus["EXPIRED"] = "expired";
    DeploymentStatus["NEW_QUOTE"] = "new_quote";
    DeploymentStatus["NOT_ACCEPTED"] = "not_accepted";
    DeploymentStatus["NO_TRADER"] = "no_trader";
    DeploymentStatus["ON_MOVE"] = "on_move";
    DeploymentStatus["PLANNED"] = "planned";
    DeploymentStatus["PROXY_FAILED"] = "proxy_failed";
    DeploymentStatus["SIGNED"] = "signed";
    DeploymentStatus["STARTED"] = "started";
    DeploymentStatus["PENDING"] = "pending";
    DeploymentStatus["PROCESSING_TRADER_PAYOUT"] = "processing_trader_payout";
})(DeploymentStatus = exports.DeploymentStatus || (exports.DeploymentStatus = {}));
exports.ASSIGNABLE = [
    DeploymentStatus.PROXY_FAILED,
    DeploymentStatus.ACCEPTED,
    DeploymentStatus.CUSTOMER_CALLED,
    DeploymentStatus.DISPATCHED,
    DeploymentStatus.NEW_QUOTE,
    DeploymentStatus.PLANNED,
    DeploymentStatus.ON_MOVE,
    DeploymentStatus.STARTED,
    DeploymentStatus.BEFORE_PHOTO_TAKEN,
    DeploymentStatus.AFTER_PHOTO_TAKEN,
];
exports.IN_PROGRESS = [
    DeploymentStatus.ON_MOVE,
    DeploymentStatus.BEFORE_PHOTO_TAKEN,
    DeploymentStatus.AFTER_PHOTO_TAKEN,
    DeploymentStatus.SIGNED,
    DeploymentStatus.STARTED,
];
//# sourceMappingURL=deployment.js.map